// extracted by mini-css-extract-plugin
export var actualite = "detailsActu-module--actualite--12f97";
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--71a55";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--6c067";
export var actualiteImg = "detailsActu-module--actualite-img--5d69b";
export var actualiteTags = "detailsActu-module--actualite-tags--84a83";
export var actualiteTaxo = "detailsActu-module--actualite-taxo--54295";
export var actualiteTitle = "detailsActu-module--actualite-title--61833";
export var pageActu = "detailsActu-module--page-actu--4c1e9";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--30627";
export var socialPanelContainer = "detailsActu-module--social-panel-container--42ad8";